export default __webpack_public_path__ + "static/media/img5.72366408.png";